import { Spinner } from '@fluentui/react-components';
import { createFileRoute } from '@tanstack/react-router';
import { lazy, Suspense } from 'react';

import { pickFilterSearch } from '../../lib/router/itemsSearchSchema';

const MergeFlowPage = lazy(() =>
  import('../../pages/items/merge/MergeFlowPage').then((m) => ({ default: m.MergeFlowPage })),
);

export const Route = createFileRoute('/items/$assetGroupId/merge')({
  validateSearch: (search: Record<string, unknown>) => pickFilterSearch(search),
  component: () => (
    <Suspense fallback={<Spinner style={{ position: 'absolute', top: '25%', left: '50%' }} />}>
      <MergeFlowPage />
    </Suspense>
  ),
});
